'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    upload: 'Upload',
    submit: 'Submit',
    cancel: 'Cancel',
    preview: 'Preview',
    'edit picture': 'Edit Picture',
    'drag to crop': 'Drag to Crop',
    'click to upload': 'Click to upload'
};
module.exports = exports['default'];